import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Venta } from 'src/app/models/venta';
import { DialogData } from '../detailventa/detailventa.component';
import * as jsPDF from 'jspdf';
import jspdf from 'jspdf';
import * as html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-detail-pdf',
  templateUrl: './detail-pdf.component.html',
  styleUrls: ['./detail-pdf.component.css']
})
export class DetailPdfComponent implements OnInit {
  public sale: Venta;
  constructor(
    public dialogRef: MatDialogRef<DetailPdfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) { }

  ngOnInit(): void {
    let aux: any = this.data
    this.sale = aux.sale;
    console.log(this.sale)
  }

  download(){
    
    const DATA: any = document.getElementById('htmlData');
    const doc = new jspdf('p', 'pt', 'a4');
    const options = {
      margin: 0.23,
      filename: `${this.sale.cliente}_Ticket_${new Date().toISOString().slice(0,10)}.pdf`,
      image: { type: 'jpeg', quality: 0.3 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      background: 'white',
    };
    let pageHeight = doc.internal.pageSize.height; // Tamaño de una pagina
    let pageHeightLeft = pageHeight; // La utilizaremos para ver cuanto espacio nos queda
    let position = 0;
    html2pdf().from(DATA).set(options).save();
  }

}
